// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1diLJ","colMin":"styles_colMin__2FQil"};